import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import {
  surveyProgressEtaHighlightSx,
  surveyProgressEtaSx,
  surveyProgressFillSx,
  surveyProgressLabelSx,
  surveyProgressMetaRowSx,
  surveyProgressSectionSx,
  surveyProgressTrackSx,
} from '../../styles/surveyExecutionStyles'

interface SurveyProgressBarProps {
  readonly currentIndex: number
  readonly total: number
  readonly estimatedCompletionMinutes?: number | null
}

export function SurveyProgressBar({
  currentIndex,
  total,
  estimatedCompletionMinutes,
}: SurveyProgressBarProps) {
  const safeTotal = Math.max(total, 1)
  const pct = Math.min(100, Math.round((currentIndex / safeTotal) * 100))

  return (
    <Box sx={surveyProgressSectionSx} data-testid="survey-progress">
      <Box sx={surveyProgressMetaRowSx}>
        <Typography component="p" sx={surveyProgressLabelSx}>
          Question {currentIndex}
        </Typography>
        {estimatedCompletionMinutes != null && estimatedCompletionMinutes > 0 ? (
          <Typography component="p" sx={surveyProgressEtaSx} data-testid="survey-progress-eta">
            Est completion time:{' '}
            <Box component="span" sx={surveyProgressEtaHighlightSx}>
              {estimatedCompletionMinutes} mins
            </Box>
          </Typography>
        ) : null}
      </Box>
      <Box sx={surveyProgressTrackSx} aria-hidden>
        <Box
          data-testid="survey-progress-fill"
          sx={{ ...surveyProgressFillSx, width: `${pct}%` }}
        />
      </Box>
    </Box>
  )
}
